import axios from 'axios'
import errorHandler from './error-handler'

const ROTA = 'https://app.rvgeventos.com.br/teleentrega/produtos'

export default {
  async cadastrar(produtoDto) {
    try {
      await axios.post(`${ROTA}`, produtoDto)
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async atualizar(produtoDto) {
    try {
      await axios.put(`${ROTA}`, produtoDto)
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaPorId(produtoId) {
    try {
      const { data } = await axios.get(`${ROTA}/filtrar-id/${produtoId}`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaTodos(pagina = 1) {
    try {
      const { data } = await axios.get(`${ROTA}/todos?pagina=${pagina}`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
  async buscaTodosSemLimite() {
    try {
      const { data } = await axios.get(`${ROTA}/todos-sem-limite`)
      return data
    } catch (error) {
      throw errorHandler.validar(error)
    }
  },
}
